import { BlocksType } from "./types";

const colors = {
  headerGrey: "#545454",
  palegreen: "#27FF97",
  blue: "#00BEFF",
  bggrey: "#f8f8f8",
  /**
   * Use this only for Node's connection indicator
   * For brand red use `fetchColor({red:"var(--foreground-red)"}).red` instead
   */
  red: "#FC7474",
  grey: "#999",
  primary: "#00BEFF",
  shadow: "rgba(27, 112, 231)",
  tickerChart: {
    candleDefault: "#102A56",
    patterned: {
      dark: "#ffffff",
      light: "#Ff0000",
    },
    chartPatterned: {
      dark: "#ffffff",
      light: "#Ff0000",
    },
  },
  transparent: "rgba(0,0,0,0)",
  foreground: "hsl(var(--foreground))",
  accent: "hsl(var(--accent))",
};

export default colors;

export const getLineColor = (type: any, name?: any, darkTheme?: boolean) => {
  switch (type) {
    case BlocksType.ACTION:
      if (["Smart Sell", "Smart Buy", "Smart Exit Position"].includes(name))
        return "#19438A";
      return "rgb(255, 105, 105)";
    case "Market data":
      return "rgb(13, 148, 103)";
    case BlocksType.DATA:
      return "rgb(13, 148, 103)";
    case BlocksType.INDICATOR:
      return "rgb(174, 187, 255)";
    case BlocksType.PATTERN:
    case BlocksType.CHART_PATTERN:
      if (typeof darkTheme === "boolean")
        return colors.tickerChart.patterned[darkTheme ? "dark" : "light"];
      return "rgb(22, 22, 22)";
    case BlocksType.TRADING_LOGIC:
      return "rgb(237, 201, 13)";
  }
};
